import queryString from 'query-string';
import { getOriginalWindowSearch } from '../actions/shared/QueryParams';

export const getAntragsaenderungState = () => {
  return queryString.parse(getOriginalWindowSearch()).antragsaenderung;
};
